import { func, number, oneOfType, string } from 'prop-types'

const Marker = ({ className,src, lat, lng, markerId, onClick, ...props }) => {
	return (
		<img
			className={className}
			src={src??"https://img.icons8.com/fluency-systems-filled/30/20C997/marker.png"}
			// eslint-disable-next-line react/no-unknown-property
			lat={lat}
			// eslint-disable-next-line react/no-unknown-property
			lng={lng}
			onClick={(e) => (onClick ? onClick(markerId) : null)}
			style={{ cursor: 'pointer', fontSize: 40 }}
			alt={markerId}
			{...props}
		/>
	)
}

Marker.defaultProps = {}

Marker.propTypes = {
	className: string,
	/**
	 * The id of the marker.
	 */
	markerId: oneOfType([number, string]).isRequired,
	/**
	 * The latitude of the marker.
	 */
	lat: number.isRequired,
	/**
	 * The longitude of the marker.
	 */
	lng: number.isRequired,
	/**
	 * The function to call when the marker is clicked.
	 */
	onClick: func,
}

export default Marker